import { render, staticRenderFns } from "./RelationshipWithSun.vue?vue&type=template&id=971f5d7e"
import script from "./RelationshipWithSun.vue?vue&type=script&lang=js"
export * from "./RelationshipWithSun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports